import axiosInstance from "@/api/axiosInstance";
import store from "../store";

import { useToast } from "../comp/useToast";
import { useDialog } from "../comp/DialogProvider";
//import { useContext } from "react";
//import { UserContext } from "../context/UserContext";
import { useSelector } from "react-redux";
//import store from "../store";
//import { logout, resetUser } from "../store/userSlice";
//import { goLogin } from "./navigation";

export const useCommon = () => {
  const showToast = useToast();
  const dialog = useDialog();
  //const { commMsg } = useContext(UserContext);
  const commMsg = useSelector((state) => state.user.commMsg);
  const commCode = useSelector((state) => state.user.commCode);

  /**
   * 메시지코드로 메시지 찾아서 파라미터 치환
   */
  const getKorMsgByCode = (code, ...params) => {
    const found = commMsg.find((msg) => msg.MSGE_CD === code);
    if (!found) return code;

    let message = found.KORN_MSGE;
    params.forEach((p, i) => {
      message = message.replace(new RegExp(`\\{${i}\\}`, "g"), p);
    });
    return message;
  };

  /**
   * 메시지코드 기반으로 팝업 또는 토스트 자동 출력
   * @param {string} code - MSGE_CD
   * @param {...any} args - [callback]?, [...params]
   */
  const showMsg = (code, ...args) => {
    const msgObj = commMsg.find((msg) => msg.MSGE_CD === code);
    if (!msgObj) {
      showToast(code);
      return;
    }

    const isConfirm = msgObj.MSGE_FLAG_CD === "CFN";

    // 파라미터 추출
    let callback = null;
    let params = [];

    if (isConfirm && typeof args[0] === "function") {
      callback = args[0];
      params = args.slice(1);
    } else {
      params = args;
    }

    const message = getKorMsgByCode(code, ...params);

    if (isConfirm) {
      dialog.showDialog({
        title: "확인",
        content: message,
        confirmText: "진행",
        cancelText: "취소",
        onConfirm: () => callback?.(true),
        onCancel: () => callback?.(false),
      });
    } else {
      showToast(message);
    }
  };

  /**
   * toast message
   * @param {string} msg - 메시지
   */
  const showToastMsg = (msg, type = "info") => {
    showToast(msg, type);
  };

  /**
   * showPopup
   * @param {string} title - 팝업 제목
   * @param {string} msg - 메시지 내용
   * @param {function} callback - 확인(진행) 버튼 클릭 시 실행할 함수
   */
  const showPopup = async (title, msg, callback) => {
    dialog.showDialog({
      title: title || "확인",
      content: msg || "저장하시겠습니까?",
      confirmText: "진행",
      cancelText: "취소",
      onConfirm: () => {
        if (typeof callback === "function") {
          callback(true);
        } else {
          alert("진행되었습니다!");
        }
      },
      onCancel: () => {
        if (typeof callback === "function") {
          callback(false);
        } else {
          alert("취소되었습니다.");
        }
      },
    });
  };

  /**
   * 공통 API 호출 함수
   * @param {string} method - 'get', 'post', 'put', 'delete'
   * @param {string} url - API URL
   * @param {object} [data] - 요청 바디 또는 파라미터
   * @param {object} [config] - 추가 Axios 설정 (headers 등)
   */
  const apiRequest = async (method, url, data = {}, config = {}) => {
    // 최초 접속의 세션 확인은 정상적으로 401을 받을 수 있습니다.
    // 401 인터셉터가 Redux 로그인 상태를 초기화하기 전에 상태를 보관합니다.
    const hadAuthenticatedSession = store.getState().user?.isLoggedIn === true ||
      Boolean(localStorage.getItem("ACCESS_TOKEN"));
    const isInitialSessionCheck = method.toLowerCase() === "get" &&
      url.split("?")[0] === "/api/front/common/check";
    try {
      const response = await axiosInstance({
        method,
        url,
        ...(method === "get" ? { params: data } : { data }),
        ...config,
        //headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      // axiosInstance에서 401처리  
      if (!response) {
        if (!isInitialSessionCheck || hadAuthenticatedSession) {
          showToast("세션이 종료되었습니다.", "error");
        }
        return null;
      }
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("[API ERROR]", error);

      /* axiosInstance로 이동
      const status = error.response?.status;

      if (status === 401) {
        // 세션 만료 처리
        store.dispatch(resetUser()); // 로그인 정보 초기화
        store.dispatch(logout());
        goLogin();
        return Promise.reject(error);
      }
      */
    
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status,
      };
    }
  };

  /**
   * @class Dataset에 설정된 정합성체크 RuleSet을 Clear한다.
   * @param {Object} obj - Grid Object
   * @return N/A
   */
  const gfnClearValidation = (obj) => {
    obj.validationRuleSet = null;
  };

  /**
   * @class Dataset의 Column별로 설정된 정합성체크 Rule을 제거한다.
   * @param  {Dataset} 데이터셋 Object
   * @param  {String} 체크대상 컬럼명
   * @return N/A
   * @example gfnRemoveValidation(this.dsList, "ID")
   */
  const gfnRemoveValidation = (obj, sColumID) => {
    var newvalidObj = [];

    if (!gfnIsNull(obj.validationRuleSet)) {
      let validObj = JSON.parse(obj.validationRuleSet);

      for (var index in validObj) {
        var validationRule = validObj[index];

        // 제거 대상이 아닐때만 정합성체크 대상에 넣는다.
        if (validationRule.name !== sColumID) {
          newvalidObj.push(validationRule);
        }
      }
    }

    obj.validationRuleSet = JSON.stringify(newvalidObj);
  };

  /**
   * @class 문자가 있는경우 assstr 문자를 합친다 <br>
   * @param {String} str - 대상문자
   * @param {String} addStr - 합칠문자
   * @param {String} sep - 구분문자자
   */
  const gfnAddString = (str, addStr, sep) => {
    if (!str) str = "";
    if (str === "") return str + addStr;
    return str + sep + addStr;
  };

  /**
   * @class Data의 Column별로 정합성체크 Rule을 등록한다.
   * @param {Object} grid - 그리드 Object
   * @param {String} sColumID - 체크대상 컬럼명
   * @param {String} sColumName - 컬럼명의 오류메세지 처리 제목
   * @param {String} sValidRule - 정합성체크 Rule(required, length, min, max, code 등의 체크 형식)
   * @return N/A
   * @example gfnSetValidation(this.dsList, "TASK_ID", "TASK ID", "required");
   */
  const gfnSetValidation = (grid, sColumID, sColumName, sValidRule) => {
    var validObj = [];
    if (sColumName.indexOf(",") !== -1)
      sColumName = sColumName.replace(/,/g, "^_^");

    // Dataset에 RuleSet이 존재하면
    if (grid.validationRuleSet) {
      validObj = JSON.parse(grid.validationRuleSet);
      for (var index in validObj) {
        // 컬럼에 Rule이 존재하면 변경 처리
        if (validObj[index].name === sColumID) {
          validObj[index].title = sColumName;
          validObj[index].value = sValidRule;
          if ("" + sValidRule.indexOf("required") > -1) {
            validObj[index].notnull = true;
          } else {
            validObj[index].notnull = false;
          }
          grid.validationRuleSet = JSON.stringify(validObj);
          return true;
        }
      }
    }

    // Rule 지정
    var validationRule = {
      name: sColumID, // Column
      title: sColumName, // Title
      value: sValidRule, // 정합성 Rule
    };

    // Rule에 필수여부 추가
    if ("" + sValidRule.indexOf("required") > -1) {
      validationRule.notnull = true;
    } else {
      validationRule.notnull = false;
    }
    validObj.push(validationRule);

    grid.validationRuleSet = JSON.stringify(validObj);
  };

  /**
   * gfnIsNull
   *
   * <p>null값 확인</p>
   *@param {String} sValue - 확인 대상
   * @return {Boolean} Null이면 true
   */
  const gfnIsNull = (sValue) => {
    if (String(sValue).valueOf() === "undefined") return true;
    if (sValue == null) return true;

    var ChkStr = String(sValue);

    if (ChkStr == null) return true;
    if (ChkStr.toString().length === 0) return true;
    return false;
  };

  /**
   * @class Dataset에 등록된 데이터 정합성체크 RuleSet에의해 정합성을 체크를 하고 이상 여부를 리턴한다.
   * @param  {Object} grid Grid object
   * @param  {Object} objRows Check 대상 Data Object
   * @return {Boolean} 정상 true / 오류 false
   */
  const gfnValidation = (grid, objRows, sCheckRow, noMsg) => {
    var objVal = objRows.rows;
    // 데이터셋의 RuleSet
    var validlist = [];
    if (grid.validationRuleSet) {
      validlist = JSON.parse(grid.validationRuleSet);
    } else {
      console.log("There is no Validation Check RuleSet.");
      return false;
    }

    //var updatecount = 0;
    // row 만큼 정합성 체크
    // objVal : row object
    for (var i = 0, len = objVal.length; i < len; i++) {
      var row = objVal[i];
      var rowData = row.data;
      //var rowtype = rowData._rowType_;
      // checkmode에 따른 체크 대상 구분

      // Rule 만큼 처리
      for (var j = 0, lenj = validlist.length; j < lenj; j++) {
        var columid = validlist[j].name;
        var columname = String(validlist[j].title);
        var columvalue = rowData[columid];
        var checklist = ("" + validlist[j].value).split(",");
        var nullcheck = validlist[j].notnull;
        var title = validlist[j].title;

        // 필수입력 체크
        if (nullcheck === true) {
          if (columvalue === undefined || columvalue === null || gfnIsNull(("" + columvalue).trim())) {
            // row 이동 및 focus 저장
            /*
            var titile = "";
            if (columname.indexOf("^_^") !== -1) {
              titile = columname.split("^_^")[0];
            } else {
              titile = columname;
            }
            */
            if(grid.selectRow) {
              grid.selectRow(row);
              grid.scrollToRow(row);
            }
            // {0} 항목은 필수입력사항입니다.
            
            if(noMsg !== true) {
              showToast((title?title:"") + " 항목은 필수 입력 사항입니다.", "warning");
            }
            return [false, columid];
          }
        }

        // 필수값이 아닌 경우는 체크할 값이 null이 아닌 경우에만 체크
        if (!gfnIsNull(columvalue)) {
          // Rule에 따른 정합성 체크
          for (var k = 0; k < checklist.length; k++) {
            var msg = "";

            // 컬럼의 두개의 값을 이용해서 처리하는 check 대상
            var checkrule = checklist[k].split(":")[0];
            if (
              checkrule === "fromto" ||
              checkrule === "fromtosmall" ||
              checkrule === "comparebig" ||
              checkrule === "comparesmall" ||
              checkrule === "compareequal"
            ) {
              var compare1;
              var compare2;

              if (checklist[k].split(":").length === 3) {
                compare1 = rowData[checklist[k].split(":")[1]];
                compare2 = rowData[checklist[k].split(":")[2]];
              } else {
                compare1 = rowData[columid];
                compare2 = rowData[checklist[k].split(":")[1]];
              }
              msg = gfnValidationCheckRule(
                columname,
                columvalue,
                checklist[k],
                compare1,
                compare2
              );
            }
            // 컬럼의 한개 값을 이용해서 처리하는 check 대상
            else {
              msg = gfnValidationCheckRule(columname, columvalue, checklist[k]);
            }

            // 에러시
            if (!gfnIsNull(msg)) {
              // row 이동 및 focus 저장
              grid.selectRow(row);
              grid.scrollToRow(row);
              // 메시지 처리 : {}
              showToast(msg?msg:"");
              return [false,columid];
            }
          } // Rule에 따른 정합성 체크
        } // 필수값이 아닌 경우는 체크할 값이 null이 아닌 경우에만 체크
      } // Rule 만큼 처리
    } // 데이터셋의 row 만큼 정합성 체크

    return [true,""];
  };

  /**
   * @class 메세지 치환
   * @param {String} msgCode - 메세지코드
   * @return {Array} [메시지, 메시지타입]
   */
  const gfnGetMessage = (msgCode) => {
    return getKorMsgByCode(msgCode, []);
    //return [msg, type];
  };

  /**
   * @class 문자열 byte 길이를 조회
   * @param {String} sVal - 문자열
   * @return {Integer} 문자열 byte 길이
   * @example gfnLengthByte(val);
   */
  const gfnLengthByte = (val) => {
    var byteLength = 0;
    var chr;

    if (gfnIsNull(val)) return 0;

    for (var valIdx = 0; valIdx < val.length; valIdx++) {
      chr = escape(val.charAt(valIdx));

      if (chr.length === 1) {
        byteLength++;
      } else if (chr.indexOf("%u") !== -1) {
        byteLength += 3;
      } else if (chr.indexOf("%") !== -1) {
        byteLength += chr.length / 3;
      }
    }
    return byteLength;
  };

  /**
   * @class 이메일 형식에 맞는지 Check한다.
   * @param {String} strValue
   * @return {Boolean}
   * @example gfnIsEmail("tobe@tobesoft.com")
   */
  const gfnIsEmail = (strValue) => {
    var retVal = false;
    var sTmp = "";
    var sRegExp = "[a-z0-9]+[a-z0-9.,]+@[a-z0-9]+[a-z0-9.,]+\\.[a-z0-9]+";

    var regexp = new RegExp(sRegExp, "ig");
    sTmp = regexp.exec(strValue);

    if (sTmp == null) {
      retVal = false;
    } else {
      if (sTmp.index === 0 && sTmp[0].length === strValue.length) {
        retVal = true;
      } else {
        retVal = false;
      }
    }
    return retVal;
  };

  /**
   * @class 전화번호or핸드폰 번호를 체크한다. <br>
   * @param {String} telNumVal - 전화번호
   * @return {Boolean}
   * @example gfnIsPhoneNum("01012345678")
   */
  const gfnIsPhoneNum = (telNumVal) => {
    var rtn = true;
    if (!gfnIsTelNum(telNumVal) && !gfnIsMobileNum(telNumVal)) {
      rtn = false;
    }
    return rtn;
  };

  /**
   * @class 주민등록번호 여부를 확인한다. <br>
   * @param {String} sJuminNo - 입력문자열(주민번호 13자리)
   * @return {Boolean}
   * @example gfnIsSSN("70012251024567")
   */
  const gfnIsSSN = (sJuminNo) => {
    var birthYear = gfnGetBirthYear(sJuminNo);

    birthYear += sJuminNo.substr(0, 2);
    var birthMonth = sJuminNo.substr(2, 2) - 1;
    var birthDate = sJuminNo.substr(4, 2);
    var birth = new Date(birthYear, birthMonth, birthDate);

    if (
      birth.getYear() % 100 !== sJuminNo.substr(0, 2) ||
      birth.getMonth() !== birthMonth ||
      birth.getDate() !== birthDate
    ) {
      return false;
    }

    // Check Sum 코드의 유효성 검사
    let buf = new Array(13);
    for (let i = 0; i < 6; i++) buf[i] = parseInt(sJuminNo.charAt(i));
    for (let i = 6; i < 13; i++) buf[i] = parseInt(sJuminNo.charAt(i));

    let multipliers = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
    let i = 0,
      sum = 0;
    for (i = 0; i < 12; i++) sum += buf[i] *= multipliers[i];

    if ((11 - (sum % 11)) % 10 !== buf[12]) {
      return false;
    } else {
      return true;
    }
  };

  /**
   * @class 전화번호를 체크한다. <br>
   * @param {String} telNumVal - 전화번호
   * @return {Boolean}
   * @example gfnIsTelNum("0221407700")
   */
  const gfnIsTelNum = (telNumVal) => {
    var sCheckRegexp = /^0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4])-?\d{3,4}-?\d{4}$/;
    return sCheckRegexp.test(telNumVal);
  };

  /**
   * @class 핸드폰번호를 체크한다. <br>
   * @param {String} telNumVal - 전화번호
   * @return {Boolean}
   * @example gfnIsMobileNum("01012345678")
   */
  const gfnIsMobileNum = (mobileVal) => {
    const reg = /^010-\d{4}-\d{4}$/;
    return reg.test(mobileVal);
  };

  /**
   * @class 사업자 등록번호 여부를 확인한다.
   * @param {String} strCustNo - 입력문자열(등록번호10자리)
   * @return {Boolean}
   * @example gfnIsBzIdNo("2118661000")
   */
  const gfnIsBzIdNo = (strCustNo) => {
    if (strCustNo.length !== 10) {
      return false;
    } else {
      var checkID = [1, 3, 7, 1, 3, 7, 1, 3, 5, 1];
      var i,
        chkSum = 0,
        c2,
        remander;

      for (i = 0; i <= 7; i++) chkSum += checkID[i] * strCustNo.charAt(i);

      c2 = "0" + checkID[8] * strCustNo.charAt(8);
      c2 = c2.substring(c2.length - 2, c2.length);

      chkSum += Math.floor(c2.charAt(0)) + Math.floor(c2.charAt(1));

      remander = (10 - (chkSum % 10)) % 10;

      if (Math.floor(strCustNo.charAt(9)) === remander) return true; // OK!
      return false;
    }
  };

  /**
   * @class 숫자체크
   * @param {String} sValue
   * @return {Boolean}
   * @example gfnIsDigit("123")
   */
  const gfnIsDigit = (sNum) => {
    var c;
    var point_cnt = 0;
    var ret = true;

    if (gfnIsNull(sNum)) return false;

    for (var i = 0; i < sNum.length; i++) {
      c = sNum.charAt(i);
      if (i === 0 && (c === "+" || c === "-"));
      else if (c >= "0" && c <= "9");
      else if (c === ".") {
        point_cnt++;
        if (point_cnt > 1) {
          ret = false;
          break;
        }
      } else {
        ret = false;
        break;
      }
    }
    return ret;
  };

  /**
   * @class 법인 등록번호 여부를 확인한다. <br>
   * @param {String} strNo - 입력문자열(법인번호13자리)
   * @return {Boolean}
   * @example gfnIsFirmIdNo("1101117635243")
   */
  const gfnIsFirmIdNo = (strNo) => {
    if (strNo.length !== 13 || !gfnIsDigit(strNo)) return false;

    var sum = 0;
    var buf = new Array(13);
    var multipliers = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2];

    for (let i = 0; i < 13; i++) {
      buf[i] = Number(strNo.charAt(i));
    }

    for (let i = 0; i < 12; i++) {
      sum += buf[i] * multipliers[i];
    }

    sum = (10 - (sum % 10)) % 10;

    if (buf[12] === sum) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * @class 년월을 입력받아 마지막 일를 반환한다(년월) <br>
   * @param {String} yyyymm - 6 / 8 자리의 숫자로 된 날짜(YYYYMM)
   * @return {String} 해당월의 마지막날 8자리
   * @example gfnGetLastDate("20020101");
   */
  const gfnGetLastDate = (yyyymm) => {
    if (!/^\d{6}$/.test(yyyymm)) {
      throw new Error("올바른 형식(YYYYMM)이 아닙니다.");
    }

    const year = parseInt(yyyymm.substring(0, 4), 10);
    const month = parseInt(yyyymm.substring(4, 6), 10);

    if (month < 1 || month > 12) {
      throw new Error("유효한 월(01~12)이 아닙니다.");
    }

    // 해당 월의 마지막 날 구하기
    const lastDay = new Date(year, month, 0).getDate();

    return `${yyyymm}${lastDay.toString().padStart(2, "0")}`;
  };

  /**
   * @class 입력 문자열중 숫자값만 남긴다.
   * @param {String} strValue - 입력문자열
   * @return {String} 숫자문자열
   * @example gfnGetDigit(strDate);
   */
  const gfnGetDigit = (strValue) => {
    var regExp = new RegExp("\\D", "g");
    var strRet = strValue.replace(regExp, "");

    return strRet;
  };

  /**
   * @class 특수문자가 있는지 Check한다. <br>
   * @param {String} strValue
   * @return {Boolean}
   * @example gfnIsSpecialChar("테스트")
   */
  const gfnIsSpecialChar = (val) => {
    //var sCheckRegexp = /[\{\}\[\]\/\?.,;:\(\)*~`!^\-_+<>@\#$%&\\\=\'\"]/gi;
    var sCheckRegexp = /[{}[\]/?.;:()*~`!^\-+<>@#%&\\="'"]/gi;
    return sCheckRegexp.test(val);
  };

  /**
   * @class 문자열이 영문+숫자인지 Check한다. <br>
   * @param {String} val - 문자열
   * @return {Boolean}
   * @example gfnIsEngNum("test123")
   */
  const gfnIsEngNum = (val) => {
    var sCheckRegexp = /^([A-Za-z0-9]+)$/;
    return sCheckRegexp.test(val);
  };

  /**
   * @class 날짜 여부를 확인한다 -  gfnIsDate내부용
   * @param {String} strDate - 6자리의 숫자로 된 날짜(YYYYMM)
   * @return {Boolean}
   * @example gfnIsYM("200201");
   */
  const gfnIsYM = (strDate) => {
    var retVal = gfnGetDigit(strDate);

    if (retVal.length !== 6) {
      return false;
    }

    // var nYear = Number(strDate.substr(0, 4)); //년도값을 숫자로
    var nMonth = Number(strDate.substr(4, 2)); //월을 숫자로

    if (nMonth < 1 || nMonth > 12) {
      return false;
    }

    return true;
  };

  /**
   * @class 날짜 여부를 확인한다 -  gfnIsDate내부용
   * @param {String} strDate - 8자리의 숫자로 된 날짜(YYYYMMDD)
   * @return {Boolean}
   * @example gfnIsYMD("20020101");
   */
  const gfnIsYMD = (strDate) => {
    var retVal = gfnGetDigit(strDate);

    if (retVal.length !== 8) {
      return false;
    }

    var strYM = strDate.substr(0, 6); //년월
    if (!gfnIsYM(strYM)) {
      return false;
    }
    var nDay = Number(strDate.substr(6, 2)); // 일자
    var nLastDay = Number(gfnGetLastDate(strYM).substr(6, 2)); //gfnGetLastDay에서 전체 20170331값이 넘어와서 .substr(6,2)추가 20170313
    if (nDay < 1 || nDay > nLastDay) {
      return false;
    }
    return true;
  };

  /**
   * @class 한글만으로 되어 있는지 Check한다. <br>
   * @param {String} strValue
   * @return {Boolean}
   * @example gfnIsKoreanChar("테스트")
   */
  const gfnIsKoreanChar = (strValue) => {
    var retVal = true;

    for (let i = 0; i < strValue.length; i++) {
      if (
        !(
          (strValue.charCodeAt(i) > 0x3130 &&
            strValue.charCodeAt(i) < 0x318f) ||
          (strValue.charCodeAt(i) >= 0xac00 && strValue.charCodeAt(i) <= 0xd7a3)
        )
      ) {
        retVal = false;
      }
    }

    return retVal;
  };

  /**
   * @class 주민번호 뒷 첫번째 자리로 년대를 return 한다. <br>
   * @param {String} sJuminNo	생년 월일 또는 주민 번호
   * @return {String} 주민번호 뒷 첫번째 자리로 년대를 return 한다.
   * @example gfnGetBirthYear("70012251024657")
   */
  const gfnGetBirthYear = (sJuminNo) => {
    if (sJuminNo.toString().length !== 13) {
      return "N";
    }

    if (!sJuminNo.match(/^\d{6}\d{7}$/)) {
      return "N";
    }

    var vGb = sJuminNo.substr(6, 1);

    if (vGb === "1" || vGb === "2" || vGb === "5" || vGb === "6") {
      return "19";
    } else if (vGb === "3" || vGb === "4" || vGb === "7" || vGb === "8") {
      return "20";
    }
  };

  /**
   * @class 데이터의 정합성을 체크하여 그 결과를 리턴한다. 메세지가 "" 널이면.. 정상 널이 아니면 실패이다.
   * @param {String} itemName - Column title
   * @param {Stirng} itemValue - Column 값
   * @param {String} validationRuleSet - validation Rule
   * @param {Stirng} compare1 - 비교대상시작값
   * @param {Stirng} compare2 - 비교대상종료값
   * @return {Stirng} 정상이면 "" 실패이면 "XXX는 7자리입니다." 와 같은 완성형 에러 메세지
   * @example  gfnValidationCheckRule(columname, columvalue, checklist[k], compare1, compare2);
   */
  const gfnValidationCheckRule = (
    itemName,
    itemValue,
    validationRuleSet,
    compare1,
    compare2
  ) => {
    var titile = "";
    var columname1 = "";
    var columname2 = "";
    if (itemName.indexOf("^_^") !== -1) {
      titile = itemName.split("^_^")[0];
      columname1 = itemName.split("^_^")[0];
      columname2 = itemName.split("^_^")[1];
    } else {
      titile = itemName;
    }

    var arrItem2 = validationRuleSet.split(":");
    var checkrule = arrItem2[0];

    checkrule = checkrule.toLowerCase();
    switch (checkrule) {
      // size 크기 지정 : length:7
      case "length":
        if ((itemValue + "").length !== parseInt(arrItem2[1])) {
          // {0} 의 입력값은 {1} 자리이어야 합니다.
          return gfnGetMessage("msg.err.validator.length", [
            titile,
            arrItem2[1],
          ]);
        }
        break;
      // 해당 숫자 이하 : max:7
      case "max":
        if (parseFloat(itemValue) > parseFloat(arrItem2[1])) {
          // {0} 은(는) {1} 보다 작아야 합니다.
          return gfnGetMessage("msg.err.validator.sizemax", [
            titile,
            arrItem2[1],
          ]);
        }
        break;
      // 해당 숫자 이상 : min:7
      case "min":
        if (parseFloat(itemValue) < parseFloat(arrItem2[1])) {
          // {0} 은(는) {1} 보다 커야 합니다.
          return gfnGetMessage("msg.err.validator.sizemin", [
            titile,
            arrItem2[1],
          ]);
        }
        break;
      // 최대 size 크기: maxlength:7
      case "maxlength":
        if (itemValue.toString().length > parseInt(arrItem2[1])) {
          // {0} 항목의 최대 입력글자수를 초과하였습니다. 최대길이 : {1}
          return gfnGetMessage("msg.err.validator.maxlength", [
            titile,
            arrItem2[1],
          ]);
        }
        break;
      // 최대 size 크기(Byte) : maxlengthB:3
      case "maxlengthbyte":
        if (gfnLengthByte(itemValue) > parseInt(arrItem2[1])) {
          // {0} 항목의 최대 입력글자수를 초과하였습니다. 최대길이 : {1} byte
          return gfnGetMessage("msg.err.validator.maxlengthB", [
            titile,
            arrItem2[1],
          ]);
        }
        break;
      // Decimal의 값의 길이 체크 : maxlengthdec:8:4
      case "maxlengthdec":
        var arrLength = itemValue.toString().split(".");
        // 정수 자리수
        if (arrLength[0].replace("-", "").length > parseInt(arrItem2[1])) {
          // {0} 은(는) {1} 보다 작아야 합니다.
          return gfnGetMessage("msg.err.validator.max", [
            titile + " 정수 자리수",
            arrItem2[1] + "자리",
          ]);
        }
        // 소수 자리수
        if (arrLength.length > 1) {
          if (arrLength[1].length > parseInt(arrItem2[2])) {
            // {0} 은(는) {1} 보다 작아야 합니다.
            return gfnGetMessage("msg.err.validator.max", [
              titile + " 소수 자리수",
              arrItem2[2] + "자리",
            ]);
          }
        }
        break;
      // 최소 size 크기: minlength:7
      case "minlength":
        if (itemValue.length < parseInt(arrItem2[1])) {
          // {0} 항목은 최소 입력글자수 이상 입력해야 합니다. 최소길이 : {1}
          return gfnGetMessage("msg.err.validator.minlength", [
            titile,
            arrItem2[1],
          ]);
        }
        break;
      // 최소 size 크기(Byte) : minlengthB:3
      case "minlengthbyte":
        if (gfnLengthByte(itemValue) < parseInt(arrItem2[1])) {
          // {0} 항목은 최소 입력글자수 이상 입력해야 합니다. 최소길이 : {1} byte
          return gfnGetMessage("msg.err.validator.minlengthB", [
            titile,
            arrItem2[1],
          ]);
        }
        break;
      // 날짜 from ~ to 비교 : comparedate:target칼럼명
      case "fromto":
        if (compare1 < compare2) {
          if (itemName.indexOf("^_^") > -1) {
            // {0} 항목은 {1} 보다 이후 날짜 이여야 합니다.
            return gfnGetMessage("msg.err.validator.fromto", [
              columname1,
              columname2,
            ]);
          }
          // 비교대상 칼럼의 title을 넘겨주지 않았을 경우 해당 값을 표시
          else {
            // {0} 항목은 {1} 보다 이후 날짜 이여야 합니다.
            return gfnGetMessage("msg.err.validator.fromto", [
              titile,
              compare2,
            ]);
          }
        }
        break;
      // 날짜 to ~ from 비교 : comparedate:target칼럼명
      case "fromtosmall":
        if (compare1 > compare2) {
          if (itemName.indexOf("^_^") > -1) {
            // {0} 항목은 {1} 보다 이전 날짜 이여야 합니다.
            return gfnGetMessage("msg.err.validator.fromtomin", [
              columname1,
              columname2,
            ]);
          }
          // 비교대상 칼럼의 title을 넘겨주지 않았을 경우 해당 값을 표시
          else {
            // {0} 항목은 {1} 보다 이전 날짜 이여야 합니다.
            return gfnGetMessage("msg.err.validator.fromtomin", [
              titile,
              compare2,
            ]);
          }
        }
        break;
      // 사이의 값인지 비교 - range:40:100
      case "range":
        if (
          parseInt(itemValue) < parseInt(arrItem2[1]) ||
          parseInt(itemValue) > parseInt(arrItem2[2])
        ) {
          // {0} 항목은 {1} 과 {2} 사이의 값이어야 합니다.
          return gfnGetMessage("msg.err.validator.range", [
            titile,
            arrItem2[1],
            arrItem2[2],
          ]);
        }
        break;
      // 이메일 체크 - isemail
      case "isemail":
        if (!gfnIsEmail(itemValue)) {
          // {0} 항목은 유효하지 않은 이메일 주소입니다.
          return gfnGetMessage("msg.err.validator.email", [titile]);
        }
        break;
      // 주민등록번호 체크 - isssn
      case "isssn":
        if (!gfnIsSSN(itemValue)) {
          // {0} 항목은 유효하지 않은 주민등록번호입니다.
          return gfnGetMessage("msg.err.validator.ssn", [titile]);
        }
        break;
      // 사업자등록번호 체크 - isbzid
      case "isbzid":
        if (!gfnIsBzIdNo(itemValue)) {
          // {0} 항목은 유효하지 않은 사업자등록번호입니다.
          return gfnGetMessage("msg.err.validator.biznum", [titile]);
        }
        break;
      // 법인등록번호 체크 - isfirmid
      case "isfirmid":
        if (!gfnIsFirmIdNo(itemValue)) {
          // {0} 항목은 유효하지 않은 법인등록번호입니다.
          return gfnGetMessage("msg.err.validator.bubin", [titile]);
        }
        break;
      // 날짜 년월일 체크 : date
      case "date":
        if (!gfnIsYMD(itemValue)) {
          // {0} 항목은 날짜 유형이 아닙니다.
          return gfnGetMessage("msg.err.validator.date", [titile]);
        }
        break;
      // 날짜 년월 체크 : dateym
      case "dateym":
        if (!gfnIsYM(itemValue)) {
          // {0} 항목은 날짜 유형이 아닙니다.
          return gfnGetMessage("msg.err.validator.date", [titile]);
        }
        break;
      // 한글 여부 : korean
      case "korean":
        if (!gfnIsKoreanChar(itemValue)) {
          // {0} 항목은 한글만 입력하셔야 합니다.
          return gfnGetMessage("msg.err.validator.hangle", [titile]);
        }
        break;
      // 숫자 여부 : digits
      case "digits":
        if (!gfnIsDigit(itemValue)) {
          // {0} 항목은 숫자만 입력하셔야 합니다.
          return gfnGetMessage("msg.err.validator.digits", [titile]);
        }
        break;
      // 영문+숫자 포함 여부 : engnum
      case "engnum":
        if (!gfnIsEngNum(itemValue)) {
          // {0} 항목은 영문+숫자 조합으로 입력하셔야 합니다.
          return gfnGetMessage("msg.err.validator.engnum", [titile]);
        }
        break;
      // 특수문자 포함 여부 : special
      case "special":
        if (gfnIsSpecialChar(itemValue)) {
          // {0} 항목은 특수문자를 입력 할 수 없습니다.
          return gfnGetMessage("msg.err.validator.notspecialchar", [titile]);
        }
        break;
      // 타 칼럼값보다 큰값인지 비교 - comparebig:target칼럼명
      case "comparebig":
        if (parseFloat(compare1) > parseFloat(compare2)) {
          if (itemName.indexOf("^_^") !== -1) {
            // {0} 은(는) {1} 보다 작아야 합니다.
            return gfnGetMessage("msg.err.validator.sizemax", [
              columname1,
              columname2,
            ]);
          }
          // 비교대상 칼럼의 title을 넘겨주지 않았을 경우 해당 값을 표시
          else {
            // {0} 은(는) {1} 보다 작아야 합니다.
            return gfnGetMessage("msg.err.validator.sizemax", [
              titile,
              compare2,
            ]);
          }
        }
        break;
      // 타 칼럼값과 작은값인지 비교 - comparesmall:comparetarget
      case "comparesmall":
        if (parseFloat(compare1) < parseFloat(compare2)) {
          if (itemName.indexOf("^_^") !== -1) {
            // {0} 은(는) {1} 보다 커야 합니다.
            return gfnGetMessage("msg.err.validator.sizemin", [
              columname1,
              columname2,
            ]);
          }
          // 비교대상 칼럼의 title을 넘겨주지 않았을 경우 해당 값을 표시
          else {
            // {0} 은(는) {1} 보다 커야 합니다.
            return gfnGetMessage("msg.err.validator.sizemin", [
              titile,
              compare2,
            ]);
          }
        }
        break;
      // 타 칼럼값과 같은 값인지 비교 - compareequal:target칼럼명
      case "compareequal":
        if (compare1 === compare2) {
          if (itemName.indexOf("^_^") !== -1) {
            // {0} 은(는) {1} 와(과) 값을 다르게 입력해야 합니다.
            return gfnGetMessage("msg.err.validator.notequalto", [
              columname1,
              columname2,
            ]);
          }
          // 비교대상 칼럼의 title을 넘겨주지 않았을 경우 해당 값을 표시
          else {
            // {0} 은(는) {1} 와(과) 값을 다르게 입력해야 합니다.
            return gfnGetMessage("msg.err.validator.notequalto", [
              titile,
              compare2,
            ]);
          }
        }
        break;
      // 전화번호 체크 - istel
      case "istel":
        if (!gfnIsTelNum(itemValue)) {
          // {0} 항목은(는) 유효하지 않은 전화번호입니다.
          return gfnGetMessage("msg.err.validator.tel", [titile]);
        }
        break;
      // 핸드폰 체크 - ismobile
      case "ismobile":
        if (!gfnIsMobileNum(itemValue)) {
          // {0} 항목은(는) 유효하지 않은 핸드폰번호입니다.
          return gfnGetMessage("msg.err.validator.phone", [titile]);
        }
        break;
      // 전화번호+핸드폰 체크 - isphone
      case "isphone":
        if (!gfnIsPhoneNum(itemValue)) {
          // {0} 항목은(는) 유효하지 않은 전화번호입니다.
          return gfnGetMessage("msg.err.validator.phone", [titile]);
        }
        break;

      default:
        return "";
    }
  };

  /**
   * @class 수신 데이터의 컬럼정보를 생성
   * @param {String} itemName - Column title
   * @param {Stirng} itemValue - Column 값
   * @param {String} validationRuleSet - validation Rule
   * @param {Stirng} compare1 - 비교대상시작값
   * @param {Stirng} compare2 - 비교대상종료값
   * @return {Stirng} 정상이면 "" 실패이면 "XXX는 7자리입니다." 와 같은 완성형 에러 메세지
   * @example  gfnValidationCheckRule(columname, columvalue, checklist[k], compare1, compare2);
   */
  const gfnHeaderSet = (
    inData
  ) => {
    if(!inData) return [];
    
    const defaultObj = inData.reduce((acc, item) => {
      acc[item.id] = item.type === "string" ? "" : null; // 숫자는 null, 문자열은 ""
      return acc;
    }, {});    

    return defaultObj;
  };  
  
  /**
   * @class 공통코드를 가져온다
   * @param {Object} option - code param
   * @return {Object} 결과 코드 object
   * @example  gfnGetComboItem(columname, columvalue, checklist[k], compare1, compare2);
   */
   const gfnGetComboItem = function (option) {
    let codeCol = "SSC_CD";
    let textCol = "SSC_CD_KORN_NM";

    let codeDatas = commCode?.data;
    if(!codeDatas || codeDatas.length === 0 ) return;

    let combos = [];
    const codes = codeDatas.filter(
      (item) => item.HCL_CD === option.listCode
    );
        
    if (option.addAll) {
      combos.push({ value: "", label: (option.allText || "선택") });
    }

    codes.forEach((code) => {
      combos.push({
        value: code[codeCol],   //실제 코드값 (SM02)
        label: code[textCol]    //화면 표시명
      });
    });
 
    return combos;
  };  

  /**
   * 엑셀 COLxxx 데이터를 Tabulator column field 기준으로 변환
   * @param {Array<Object>} excelData - [{COL000:..., COL001:...}, ...]
   * @param {Object} table - Tabulator table instance
   * @returns {Array<Object>}
   */
  const mapExcelDataToTabulator = function(excelData, table) {
      if (!Array.isArray(excelData) || !table?.columnManager?.columns) {
          return [];
      }

      // Tabulator column field 목록 (순서 중요)
      const fields = table.columnManager.columns
          .map(col => col.getField?.() ?? col.field)
          .filter(Boolean);

      return excelData.map(row => {
          const newRow = {};

          fields.forEach((field, idx) => {
              const colKey = "COL" + String(idx).padStart(3, "0");
              newRow[field] = row[colKey];
          });

          return newRow;
      });
  }


  return {
    showMsg,
    showToastMsg,
    showPopup,
    apiRequest,
    gfnClearValidation,
    gfnSetValidation,
    gfnValidation,
    gfnHeaderSet,
    gfnGetComboItem,
    mapExcelDataToTabulator,
  };
};
